export const homeHero = {
  name: "水野朝阳",
  nameEn: "Mizuno Asahi",
  tagline: "以真诚演绎每一刻，用作品连接每一位支持者",
  subTagline: "日本知名女演员 · 2013年出道至今",
  heroImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20female%20celebrity%20atmospheric%20portrait%20with%20soft%20golden%20spotlight%20on%20dark%20stage%20background%2C%20cinematic%20lighting%2C%20professional%20photography%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20refined%20artistic%20composition%2C%20shallow%20depth%20of%20field%2C%20glamorous%20yet%20sophisticated%20mood&width=1600&height=900&seq=mizuno-hero-2026&orientation=landscape"
};

export const siteInfo = {
  name: "水野朝阳官方粉丝站",
  description: "水野朝阳专属落地页，深度呈现水野朝阳的个人资料、作品经历、最新动态与粉丝社群入口。无论你是新粉还是资深支持者，这里是了解水野朝阳最权威、最全面的一站式平台。",
  keywords: "水野朝阳,水野朝阳作品,水野朝阳个人资料,水野朝阳最新动态,水野朝阳粉丝社群,水野朝阳经历,水野朝阳官方信息",
  url: "https://mizunocore.github.io",
  locale: "zh_CN",
};

export const profileData = {
  name: "水野朝阳",
  nameEn: "Mizuno Asahi",
  birthDate: "1990年11月12日",
  birthPlace: "日本东京都",
  height: "165cm",
  measurements: "B90 / W58 / H88",
  debut: "2013年",
  agency: "T-POWERS",
  hobbies: ["瑜伽", "旅行", "料理", "读书"],
  specialties: ["钢琴", "英语会话"],
  socialLinks: {
    twitter: "https://twitter.com/mizuno_asahi",
    instagram: "https://instagram.com/mizuno_asahi",
  },
  bio: "水野朝阳于2013年正式出道，凭借出众的外形条件与扎实的演技功底迅速获得业界关注。她以自然真实的表现风格著称，在十余年的职业生涯中累计出演超过500部作品，多次入围业界重要奖项。除演艺事业外，水野朝阳积极拓展个人品牌，活跃于社交媒体与粉丝互动，以真诚亲和的态度赢得了广泛的支持与喜爱。她在工作中始终保持专业精神，在私人生活中热爱旅行与美食，展现出多面而真实的个人魅力。",
};

export const statsData = [
  { label: "出道年数", value: "13年", icon: "ri-calendar-check-line" },
  { label: "作品总数", value: "500+", icon: "ri-film-line" },
  { label: "粉丝数量", value: "120万+", icon: "ri-heart-line" },
  { label: "获奖记录", value: "15项", icon: "ri-award-line" },
];

export const featuredWorks = [
  {
    id: 1,
    title: "阳光下的邂逅",
    category: "剧情系列",
    year: "2024",
    image: "https://readdy.ai/api/search-image?query=Japanese%20elegant%20woman%20in%20warm%20sunlight%20through%20window%2C%20soft%20romantic%20atmosphere%2C%20natural%20makeup%2C%20cream%20colored%20interior%2C%20professional%20cinematic%20lighting%2C%20artistic%20portrait%20style%2C%20warm%20golden%20hour%20glow&width=400&height=560&seq=mizuno-work-01&orientation=portrait",
    rating: 4.8,
  },
  {
    id: 2,
    title: "夜的第七章",
    category: "剧情系列",
    year: "2024",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20evening%20dress%20under%20soft%20city%20night%20lights%2C%20sophisticated%20mood%2C%20warm%20amber%20lighting%2C%20refined%20cinematic%20portrait%2C%20luxurious%20atmosphere%2C%20shallow%20depth%20of%20field&width=400&height=560&seq=mizuno-work-02&orientation=portrait",
    rating: 4.7,
  },
  {
    id: 3,
    title: "夏日记忆",
    category: "青春系列",
    year: "2023",
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20woman%20in%20summer%20garden%20with%20soft%20natural%20lighting%2C%20white%20dress%2C%20gentle%20breeze%2C%20pastel%20floral%20background%2C%20fresh%20and%20youthful%20vibe%2C%20professional%20photography%2C%20warm%20tones&width=400&height=560&seq=mizuno-work-03&orientation=portrait",
    rating: 4.9,
  },
  {
    id: 4,
    title: "东京恋语",
    category: "都市系列",
    year: "2023",
    image: "https://readdy.ai/api/search-image?query=Stylish%20Japanese%20woman%20in%20modern%20Tokyo%20apartment%2C%20cityscape%20through%20large%20window%2C%20warm%20interior%20lighting%2C%20elegant%20casual%20outfit%2C%20contemporary%20lifestyle%20aesthetic%2C%20professional%20portrait%20photography&width=400&height=560&seq=mizuno-work-04&orientation=portrait",
    rating: 4.6,
  },
];

export const newsArticles = [
  {
    id: 1,
    title: "水野朝阳2025年最新作品发布会圆满举行",
    excerpt: "水野朝阳出席了在东京举办的2025年度新作发布会，现场分享了创作背后的故事与心路历程，引发粉丝热烈反响。",
    date: "2025-03-15",
    category: "活动报道",
    image: "https://readdy.ai/api/search-image?query=Press%20conference%20event%20with%20elegant%20Japanese%20woman%20on%20stage%2C%20professional%20lighting%2C%20warm%20atmosphere%2C%20audience%20in%20background%2C%20event%20photography%20style%2C%20sophisticated%20venue&width=600&height=400&seq=mizuno-news-01&orientation=landscape",
  },
  {
    id: 2,
    title: "粉丝见面会精彩回顾：感恩一路相伴",
    excerpt: "上周末于大阪举办的粉丝见面会圆满落幕，水野朝阳与数百名粉丝亲密互动，现场气氛温馨感人，共同度过难忘时光。",
    date: "2025-02-28",
    category: "粉丝活动",
    image: "https://readdy.ai/api/search-image?query=Fan%20meeting%20event%20with%20Japanese%20celebrity%20waving%20to%20crowd%2C%20warm%20interactions%2C%20indoor%20event%20space%2C%20joyful%20atmosphere%2C%20professional%20event%20photography%2C%20soft%20lighting&width=600&height=400&seq=mizuno-news-02&orientation=landscape",
  },
  {
    id: 3,
    title: "水野朝阳荣获年度最佳女演员提名",
    excerpt: "业界权威奖项公布年度提名名单，水野朝阳凭借过去一年的出色表现再度获得最佳女演员提名，这是对她专业能力的又一次肯定。",
    date: "2025-01-20",
    category: "荣誉奖项",
    image: "https://readdy.ai/api/search-image?query=Award%20ceremony%20red%20carpet%20with%20elegant%20Japanese%20woman%20in%20sophisticated%20gown%2C%20golden%20lighting%2C%20prestigious%20venue%2C%20glamorous%20atmosphere%2C%20professional%20event%20photography&width=600&height=400&seq=mizuno-news-03&orientation=landscape",
  },
  {
    id: 4,
    title: "新年问候：水野朝阳的2025年展望",
    excerpt: "在新年伊始，水野朝阳通过官方粉丝站向所有支持者致以诚挚问候，并分享了新一年的工作计划与个人目标，期待与粉丝共同成长。",
    date: "2025-01-01",
    category: "个人动态",
    image: "https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20traditional%20kimono%20during%20New%20Year%20celebration%2C%20warm%20sunlight%2C%20elegant%20traditional%20Japanese%20room%2C%20peaceful%20atmosphere%2C%20soft%20natural%20lighting%2C%20refined%20portrait%20style&width=600&height=400&seq=mizuno-news-04&orientation=landscape",
  },
];

export const faqData = [
  {
    question: "水野朝阳是什么时候出道的？",
    answer: "水野朝阳于2013年正式出道，至今已有十余年的演艺经历，是业界备受尊敬的实力派女演员。",
  },
  {
    question: "如何获取水野朝阳的最新作品信息？",
    answer: "您可以通过本网站的「作品浏览」页面查看按分类整理的作品信息。同时，关注水野朝阳的官方社交媒体账号也可以第一时间获取最新作品发布动态。",
  },
  {
    question: "水野朝阳有官方粉丝社群吗？",
    answer: "是的，水野朝阳在各大社交平台均设有官方账号，粉丝可以通过Twitter和Instagram关注她的日常动态。此外，本站也会定期发布粉丝活动相关信息。",
  },
  {
    question: "如何联系水野朝阳进行商务合作？",
    answer: "商务合作请联系水野朝阳所属经纪公司T-POWERS。您也可以访问本站「关于我们」页面获取联系信息。",
  },
  {
    question: "水野朝阳的下一步工作计划是什么？",
    answer: "水野朝阳目前正在积极筹备2025年的全新企划，包括新作品拍摄、粉丝见面会以及个人品牌的拓展。具体信息将通过官方渠道陆续公布。",
  },
];

export const communityInfo = {
  title: "加入粉丝社群",
  description: "与水野朝阳的全球粉丝一起，获取独家内容、参与线上活动、优先了解最新动态。成为社群的一员，与志同道合的朋友分享对水野朝阳的喜爱。",
  features: [
    { icon: "ri-message-3-line", title: "独家内容", desc: "获取社群专属的幕后花絮与未公开照片" },
    { icon: "ri-calendar-event-line", title: "活动优先", desc: "抢先获得粉丝见面会及线上活动的参与机会" },
    { icon: "ri-group-line", title: "志趣相投", desc: "与来自世界各地的粉丝交流分享，建立友谊" },
  ],
};